import React from "react";
import { maturityLevels } from "../../data/research";
import { SectionLabel } from "../SectionLabel";
export function MaturityModel() {
  return <section id="maturity-model" aria-labelledby="maturity-title" className="scroll-mt-28 border-t border-stone" data-id="element-493" data-mp="1sxdikio9kylg">
      <div className="shell py-24 md:py-32" data-id="element-494" data-mp="26sz2wcjjyu7j">
        <div className="grid grid-cols-12 gap-x-6 gap-y-8 pb-14" data-id="element-495" data-mp="21v79fe39f018">
          <div className="col-span-12 lg:col-span-3 lg:pt-3" data-id="element-496" data-mp="2fvrtseotp3wu">
            <SectionLabel data-id="element-497" data-mp="2fu70ese8vr0k">Framework</SectionLabel>
          </div>
          <div className="col-span-12 lg:col-span-9" data-id="element-498" data-mp="2btdaxul5m45k">
            <h2 id="maturity-title" className="font-display text-[clamp(2.25rem,4.6vw,4rem)] leading-[1.05] text-navy" data-id="element-499" data-mp="2bslob99jbgrf">
              The Payroll Maturity Model™
            </h2>
            <p className="mt-6 max-w-xl leading-relaxed text-charcoal/75" data-id="element-500" data-mp="2kni6grb8g3rf">
              Five stages that describe how well payroll — and the HR technology behind it — is run. Most organizations
              we meet sit at stage II: on time, and dependent on the people running it.
            </p>
          </div>
        </div>

        <ol className="grid grid-cols-1 border-t border-navy md:grid-cols-5" data-id="element-501" data-mp="5gvllqptt3dg">
          {maturityLevels.map((l, i) => {
          const last = i === maturityLevels.length - 1;
          return <li key={l.name} className={`flex flex-col border-b border-stone py-8 md:border-b-0 md:pr-6 ${i > 0 ? "md:border-l md:pl-6" : ""}`} data-id="element-502" data-mp="ehblkq7d1sdk" data-mpi={i}>
                <span className="font-display text-2xl text-oxblood" data-id="element-503" data-mp="ofrd2uaav3nl">{l.numeral}</span>
                <h3 className="mt-3 font-display text-3xl text-navy" data-id="element-504" data-mp="odenpw27pr0i">{l.name}</h3>
                <p className="mt-4 text-[15px] leading-relaxed text-charcoal/75" data-id="element-505" data-mp="t79chdwocw6g">{l.line}</p>
                <div className="mt-auto pt-10" aria-hidden data-id="element-506" data-mp="x79sv43c3hg5">
                  <span className={`block w-full ${last ? "bg-oxblood" : "bg-navy"}`} style={{
                height: `${(i + 1) * 10}px`
              }} data-id="element-507" data-mp="127xhxk805o7q" />
                </div>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}